<script setup>
import { ref, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { SidebarPanel } from '@/components/ui/sidebar-panel'

// Props
const props = defineProps({
  isFullWidth: {
    type: Boolean,
    default: false
  }
})

// Emits
const emit = defineEmits(['toggle-full-width'])

// Router
const router = useRouter()
const route = useRoute()

const isShow = ref(true)

const shouldShow = computed(() => {
  return route.meta.layout !== 'hide'
})

const handleClose = () => {
  isShow.value = false
}

router.afterEach(() => {
  isShow.value = true
})
</script>

<template>
  <router-view v-slot="{ Component }">
    <SidebarPanel
      v-if="Component && Component.type?.name !== 'EmptyLayout' && shouldShow"
      :title="route.meta.title"
      :layout="route.meta.layout"
      :is-full-width="isFullWidth"
      :show="isShow"
      @toggle-full-width="emit('toggle-full-width')"
      @close="handleClose"
    >
      <component :is="Component" />
    </SidebarPanel>
  </router-view>
</template>
